export default __webpack_public_path__ + "static/media/brand4.ca805cd8.svg";